// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"6fc554e9","3":"cff6d2d4"}[chunkId] + ".chunk.js";
};